import { defineStore } from 'pinia';
import { ref } from 'vue';
import { LangCode } from '../types/lang';
import { langService } from '../services';
import { createI18n } from 'petite-vue-i18n';

export const useLangStore = defineStore('lang', () => {
    const locale = ref<LangCode>(LangCode.en)

    const i18n = createI18n({
        legacy: false,
        locale: locale.value,
        fallbackLocale: LangCode.en,
        warnHtmlMessage: false,
        missingWarn: false,
        fallbackWarn: false
    })

    async function setLocale(langCode?: LangCode) {
        langCode = langCode || locale.value
        const messages = await langService.getLanguageMessages(langCode)
        i18n.global.setLocaleMessage(langCode, messages)
        i18n.global.locale.value = langCode
        locale.value = langCode
        document.documentElement.setAttribute('lang', langCode)
    }

    return { locale, i18n, setLocale }
}, {
    persist: true
})